function modal() {
    const openModal = document.querySelectorAll('[data-modal-open]');
    const visibleClass = 'is-visible';
    
    for (const m of openModal) {
        m.addEventListener('click', function() {
            const modalID = m.dataset.target;
            document.getElementById(modalID).classList.add(visibleClass);        
        });        
    }
    
    const closeModal = document.querySelectorAll('[data-modal-close]');
    for (const c of closeModal) {
        c.addEventListener('click', function() {
            const modalID = c.dataset.modalClose;
            document.getElementById(modalID).classList.remove(visibleClass);     
        });
    }
    
    document.addEventListener('click', e => {
        if (e.target === document.querySelector('.modal.is-visible')) {
            document.querySelector('.modal.is-visible').classList.remove(visibleClass);
        }
    });
    
    document.addEventListener('keyup', e => {        
        if (e.key === 'Escape' && document.querySelector('.modal.is-visible')) {
            document.querySelector('.modal.is-visible').classList.remove(visibleClass);
        }
    });   
         
}

export default modal;